<style lang="less">
  .image-uploader {
    .el-upload {
      width: 128px;
      height: 128px;
      i {
        position: relative;
        top: -5px;
      }
    }
    .el-upload-list {
      &__item {
        width: 128px;
        height: 128px;
      }
    }
  }
  .card {
    border: none;
    .card-header {
      font-size: 15px;
    }
  }
  .item-tips {
    font-size: 13px;
    line-height: 13px;
    color: #a3a3a3;
  }
  .custom-error-bc textarea {
    border-color: #f56c6c;
  }
  .custom-error-bc textarea:hover {
    border-color: #f56c6c;
  }
  .custom-error-bc textarea:focus {
    border-color: #f56c6c;
  }
  .custom-error-mb-def {
    margin-bottom: 22px;
  }
  .custom-error-mb-cus {
    margin-bottom: 6px;
  }
</style>

<template>
  <el-card>
    <div slot="header">
      <h1>{{ activity ? '“' + activity.activityName + '”' : '' }}页面设置</h1>
    </div>
    <el-tabs type="card" v-model="tabName" @tab-click="handleClick" :before-leave="handleLeave">
      <el-tab-pane label="首页显示设置" name="home-show">首页显示设置</el-tab-pane>
      <el-tab-pane label="轮播图" name="carousel-list">轮播图</el-tab-pane>
      <el-tab-pane label="本月主打" name="flagship">本月主打</el-tab-pane>
      <el-tab-pane label="商品推荐" name="recommend">
        <div style="padding: 0 20px;margin-top: 25px">
          <el-form ref="form" :model="form" :rules="rules" @validate="formValidate" v-loading="loading" label-width="110px">
            <el-card class="card" :body-style="cardBodyStyle">
              <div slot="header" class="card-header">
                <span>手表</span>
              </div>
              <el-form-item label="广告图上传：" prop="watch.bannerPath">
                <el-upload class="image-uploader" :action="uploadPath" list-type="picture-card"
                           :auto-upload="true" :headers="headers" :data="uploadParam.watch"
                           :on-success="handleSuccess" :on-error="handleError" :on-exceed="handleExceed"
                           accept=".jpg,.jpeg,.png"
                           :beforeUpload="beforeAdUpload"
                           :limit="1" :file-list="fileList.watch">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="加载失败"/>
                    <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="handleRemove(file, 'watch')">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">建议上传文件大小不超过500K，尺寸(1270 × 360)</div>
              </el-form-item>
              <el-form-item label="跳转链接：" prop="watch.bannerUrl">
                <el-input v-model="form.watch.bannerUrl" placeholder="请输入跳转链接" :clearable="true" style="width: 500px"/>
              </el-form-item>
              <el-form-item label="推荐商品：" prop="watch.mainProducts" :class="customMarginBottom(customError.watchMainProducts)">
                <el-input type="textarea" v-model="form.watch.mainProducts" rows="3" @blur="customErrorClean('watch')" :class="customError.watchMainProducts ? 'custom-error-bc': ''" style="width: 500px"></el-input>
                <div v-if="customError.watchMainProducts" class="el-form-item__error" v-html="customError.watchMainProducts" style="position: static"></div>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">推荐商品设置，可录入商品编码，多个编码使用英文“,”隔开</div>
              </el-form-item>
            </el-card>
            <el-card class="card" :body-style="cardBodyStyle">
              <div slot="header" class="card-header">
                <span>乐器</span>
              </div>
              <el-form-item label="广告图上传：" prop="digitalPiano.bannerPath">
                <el-upload class="image-uploader" :action="uploadPath" list-type="picture-card"
                           :auto-upload="true" :headers="headers" :data="uploadParam.digitalPiano"
                           :on-success="handleSuccess" :on-error="handleError" :on-exceed="handleExceed"
                           accept=".jpg,.jpeg,.png"
                           :beforeUpload="beforeAdUpload"
                           :limit="1" :file-list="fileList.digitalPiano">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="加载失败"/>
                    <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="handleRemove(file, 'digitalPiano')">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">建议上传文件大小不超过500K，尺寸(1270 × 360)</div>
              </el-form-item>
              <el-form-item label="跳转链接：" prop="digitalPiano.bannerUrl">
                <el-input v-model="form.digitalPiano.bannerUrl" placeholder="请输入跳转链接" :clearable="true" style="width: 500px"/>
              </el-form-item>
              <el-form-item label="推荐商品：" prop="digitalPiano.mainProducts" :class="customMarginBottom(customError.digitalPianoMainProducts)">
                <el-input type="textarea" v-model="form.digitalPiano.mainProducts" rows="3" @blur="customErrorClean('digitalPiano')" :class="customError.digitalPianoMainProducts ? 'custom-error-bc': ''" style="width: 500px"></el-input>
                <div v-if="customError.digitalPianoMainProducts" class="el-form-item__error" v-html="customError.digitalPianoMainProducts" style="position: static"></div>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">推荐商品设置，可录入商品编码，多个编码使用英文“,”隔开</div>
              </el-form-item>
            </el-card>
            <el-card class="card" :body-style="cardBodyStyle">
              <div slot="header" class="card-header">
                <span>电子辞典</span>
              </div>
              <el-form-item label="广告图上传：" prop="eEducation.bannerPath">
                <el-upload class="image-uploader" :action="uploadPath" list-type="picture-card"
                           :auto-upload="true" :headers="headers" :data="uploadParam.eEducation"
                           :on-success="handleSuccess" :on-error="handleError" :on-exceed="handleExceed"
                           accept=".jpg,.jpeg,.png"
                           :beforeUpload="beforeAdUpload"
                           :limit="1" :file-list="fileList.eEducation">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="加载失败"/>
                    <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="handleRemove(file, 'eEducation')">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">建议上传文件大小不超过500K，尺寸(1270 × 360)</div>
              </el-form-item>
              <el-form-item label="跳转链接：" prop="eEducation.bannerUrl">
                <el-input v-model="form.eEducation.bannerUrl" placeholder="请输入跳转链接" :clearable="true" style="width: 500px"/>
              </el-form-item>
              <el-form-item label="推荐商品：" prop="eEducation.mainProducts" :class="customMarginBottom(customError.eEducationMainProducts)">
                <el-input type="textarea" v-model="form.eEducation.mainProducts" rows="3" @blur="customErrorClean('eEducation')" :class="customError.eEducationMainProducts ? 'custom-error-bc': ''" style="width: 500px"></el-input>
                <div v-if="customError.eEducationMainProducts" class="el-form-item__error" v-html="customError.eEducationMainProducts" style="position: static"></div>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">推荐商品设置，可录入商品编码，多个编码使用英文“,”隔开</div>
              </el-form-item>
            </el-card>
            <el-card class="card" :body-style="cardBodyStyle">
              <div slot="header" class="card-header">
                <span>计算器</span>
              </div>
              <el-form-item label="广告图上传：" prop="calculator.bannerPath">
                <el-upload class="image-uploader" :action="uploadPath" list-type="picture-card"
                           :auto-upload="true" :headers="headers" :data="uploadParam.calculator"
                           :on-success="handleSuccess" :on-error="handleError" :on-exceed="handleExceed"
                           accept=".jpg,.jpeg,.png"
                           :beforeUpload="beforeAdUpload"
                           :limit="1" :file-list="fileList.calculator">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="加载失败"/>
                    <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="handleRemove(file, 'calculator')">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">建议上传文件大小不超过500K，尺寸(1270 × 360)</div>
              </el-form-item>
              <el-form-item label="跳转链接：" prop="calculator.bannerUrl">
                <el-input v-model="form.calculator.bannerUrl" placeholder="请输入跳转链接" :clearable="true" style="width: 500px"/>
              </el-form-item>
              <el-form-item label="推荐商品：" prop="calculator.mainProducts" :class="customMarginBottom(customError.calculatorMainProducts)">
                <el-input type="textarea" v-model="form.calculator.mainProducts" rows="3" @blur="customErrorClean('calculator')" :class="customError.calculatorMainProducts ? 'custom-error-bc': ''" style="width: 500px"></el-input>
                <div v-if="customError.calculatorMainProducts" class="el-form-item__error" v-html="customError.calculatorMainProducts" style="position: static"></div>
              </el-form-item>
              <el-form-item label="">
                <div class="item-tips">推荐商品设置，可录入商品编码，多个编码使用英文“,”隔开</div>
              </el-form-item>
            </el-card>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="加载失败"/>
            </el-dialog>
            <el-form-item style="margin-top: 40px">
              <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'
  import store from '@/store'
  const { mapGetters } = createNamespacedHelpers('activityPagesettings')
  const signEnum = {
    watch: 'watch',
    digitalPiano: 'digital-piano',
    eEducation: 'e-education',
    calculator: 'calculator'
  }

  export default {
    data() {
      return {
        tabName: 'recommend',
        activity: null,
        loading: false,
        isEdit: false,
        isChange: false,
        id: {
          watch: 0,
          digitalPiano: 0,
          eEducation: 0,
          calculator: 0
        },
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: {
          watch: [],
          digitalPiano: [],
          eEducation: [],
          calculator: []
        },
        uploadParam: {
          watch: {
            folder: 'activityPagesettings',
            sign: 'watch'
          },
          digitalPiano: {
            folder: 'activityPagesettings',
            sign: 'digitalPiano'
          },
          eEducation: {
            folder: 'activityPagesettings',
            sign: 'eEducation'
          },
          calculator: {
            folder: 'activityPagesettings',
            sign: 'calculator'
          }
        },
        form: {
          watch: {
            bannerPath: '',
            bannerUrl: '',
            mainProducts: ''
          },
          digitalPiano: {
            bannerPath: '',
            bannerUrl: '',
            mainProducts: ''
          },
          eEducation: {
            bannerPath: '',
            bannerUrl: '',
            mainProducts: ''
          },
          calculator: {
            bannerPath: '',
            bannerUrl: '',
            mainProducts: ''
          }
        },
        customError: {
          watchMainProducts: '',
          digitalPianoMainProducts: '',
          eEducationMainProducts: '',
          calculatorMainProducts: ''
        },
        cardBodyStyle: {
          padding: '20px 40px'
        }
      }
    },
    inject: ['reload'],
    computed: {
      uploadPath() {
        return this.$config.api.baseURL + '/activity-image-upload'
      },
      headers() {
        const { token } = store.state.auth
        return {
          'Authorization': `Bearer ${token}`
        }
      },
      rules() {
        const checkUrl = (rule, value, callback) => {
          if (value === '') {
            callback()
          } else {
            if (!(/^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/.test(value))) {
              callback(new Error('请输入正确格式链接地址'))
            } else {
              callback()
            }
          }
        }
        const checkMainProducts = (rule, value, callback) => {
          let valueFormat = this.formatMainProducts(value)
          if (valueFormat === '') {
            callback()
          } else {
            if (!(/^([0-9A-Za-z\-]+,)*([0-9A-Za-z\-]+),?$/.test(valueFormat))) {
              callback(new Error('商品编码格式错误'))
            } else {
              valueFormat = valueFormat.replace(/,$/, '')
              const valueArr = valueFormat.split(',')
              if (valueArr.length > 12) {
                callback(new Error('商品编码最多12个'))
              } else {
                const filterUnique = arr => arr.filter(i => arr.indexOf(i) !== arr.lastIndexOf(i))
                const duplication = arr => [...new Set(arr)]
                const uniqueValueArr = duplication(filterUnique(valueArr))
                if (uniqueValueArr.length) {
                  callback(new Error('商品编码重复：' + uniqueValueArr.join('，')))
                } else {
                  callback()
                }
              }
            }
          }
        }
        return {
          watch: {
            bannerPath: this.$formHelper.requiredRuleFactory('请上传图片'),
            bannerUrl: [{ validator: checkUrl, trigger: 'blur' }],
            mainProducts: [{ validator: checkMainProducts, trigger: 'blur' }]
          },
          digitalPiano: {
            bannerPath: this.$formHelper.requiredRuleFactory('请上传图片'),
            bannerUrl: [{ validator: checkUrl, trigger: 'blur' }],
            mainProducts: [{ validator: checkMainProducts, trigger: 'blur' }]
          },
          eEducation: {
            bannerPath: this.$formHelper.requiredRuleFactory('请上传图片'),
            bannerUrl: [{ validator: checkUrl, trigger: 'blur' }],
            mainProducts: [{ validator: checkMainProducts, trigger: 'blur' }]
          },
          calculator: {
            bannerPath: this.$formHelper.requiredRuleFactory('请上传图片'),
            bannerUrl: [{ validator: checkUrl, trigger: 'blur' }],
            mainProducts: [{ validator: checkMainProducts, trigger: 'blur' }]
          }
        }
      },
      ...mapGetters(['collection'])
    },
    methods: {
      handleClick(tab) {
        if (tab.name != this.tabName) {
          if (this.isChange) {
            this.$confirm('您当前编辑结果未提交，是否确定离开？', '提示', {
              type: 'warning'
            }).then(() => {
              this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
            }).catch(() => {
              return false
            })
          } else {
            this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
          }
        }
      },
      handleLeave() {
        return false
      },
      formValidate() {
        this.isChange = true
      },
      async checkSubmit() {
        try {
          await new Promise((resolve, reject) => {
            this.$refs['form'].validate((valid) => {
              valid ? resolve(true) : reject(false)
            })
          })
          await new Promise(async (resolve, reject) => {
            let success = true
            for (const sign in signEnum) {
              const signMainProductsKey = sign + 'MainProducts'
              const signMainProductsArr = this.formatMainProductsArr(this.form[sign].mainProducts)
              if (signMainProductsArr.length) {
                await this.$store.dispatch('activityApply/checkMainProducts', { activityId: this.activity.id, mainProducts: signMainProductsArr }).then(res => {
                  if (res.code) {
                    success = false
                    this.customError[signMainProductsKey] = this.formatCustomErrorMainProducts(res.errMsg, res.defectMainProducts)
                  }
                })
              }
            }
            if (!success) {
              reject(false)
            } else {
              resolve(true)
            }
          })
        } catch (e) {
          return false
        }
        return true
      },
      async onSubmit() {
        const checkSubmit = await this.checkSubmit()
        if (!checkSubmit) {
          return false
        }
        const formData = _.cloneDeep(this.form)
        const formatFormData = this.formatFormData(formData)
        const { pushFormCreateData, pushFormUpdateData } = this.concatPushFormData(formatFormData)
        const updateQuery = {
          queryPrams: {
            query: {}
          },
          data: pushFormUpdateData
        }
        try {
          if (pushFormCreateData.length) {
            await this.$store.dispatch('activityPagesettings/batchCreate', pushFormCreateData)
          }
          if (this.isEdit && pushFormUpdateData.length) {
            await this.$store.dispatch('activityPagesettings/batchUpdate', updateQuery)
          }
          this.$message.success('提交成功')
          this.reload()
        } catch (err) {
          this.$message.error(err.response.data.message)
        }
        this.loading = false
      },
      handleRemove(file, sign) {
        this.fileList[sign] = []
        this.form[sign].bannerPath = ''
        this.isChange = true
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleSuccess(res, file) {
        const sign = res.data.sign
        this.fileList[sign].push(file)
        this.form[sign].bannerPath = res.data.url
        this.loading = false
        this.isChange = true
      },
      handleError() {
        this.$message.error('上传失败')
        this.loading = false
        this.isChange = true
      },
      handleExceed() {
        this.$message.warning('只能上传一张图片')
        return false
      },
      beforeAdUpload(file) {
        const isLt4M = file.size / 1024 / 1024 <= 4
        if(!isLt4M) {
          this.$message.warning('上传图片文件大小不能超过4M')
          return false
        }
        this.loading = true
      },
      async init() {
        let queryName = ''
        for (const sign in signEnum) {
          queryName += '"' + signEnum[sign] + '", '
        }
        queryName = queryName !== '' ? queryName.replace(/, $/, '') : queryName
        queryName = '[' + queryName + ']'
        const query = {
          activityId: this.activity.id,
          stage: 'home',
          name: queryName
        }
        const { collection } = await this.$store.dispatch('activityPagesettings/collection', { query })
        if (collection.length) {
          this.isEdit = true
          this.initForm()
        }
      },
      formatMainProducts(value) {
        value = value.replace(/[\s]/g, '')
        return value
      },
      formatMainProductsArr(value) {
        value = this.formatMainProducts(value)
        value = value.replace(/,$/, '')
        if (value !== '') {
          if (/^([0-9A-Za-z\-]+,)*([0-9A-Za-z\-]+)$/.test(value)) {
            return value.split(',')
          } else {
            return []
          }
        } else {
          return []
        }
      },
      formatFormData(formData) {
        for (const sign in signEnum) {
          formData[sign].mainProducts = this.formatMainProductsArr(formData[sign].mainProducts)
        }
        return formData
      },
      concatPushFormData(formData) {
        const pushFormData = {
          pushFormCreateData: [],
          pushFormUpdateData: []
        }
        for (const sign in signEnum) {
          const pushFormDataEach = {
            activityId: this.activity.id,
            stage: 'home',
            name: signEnum[sign],
            content: formData[sign]
          }
          if (this.id[sign]) {
            pushFormDataEach.id = this.id[sign]
            pushFormData.pushFormUpdateData.push(pushFormDataEach)
          } else {
            pushFormData.pushFormCreateData.push(pushFormDataEach)
          }
        }
        return pushFormData
      },
      formatCustomErrorMainProducts(errMsg, defectMainProducts) {
        let mainProductsErrMsg = errMsg
        if (defectMainProducts.length) {
          mainProductsErrMsg += '：'
          defectMainProducts.forEach((item, index) => {
            mainProductsErrMsg += item + '，'
            if (index % 3 == 2) {
              mainProductsErrMsg += '<br/>'
              mainProductsErrMsg += index ? '&nbsp;'.repeat(28) : ''
            }
          })
          mainProductsErrMsg = mainProductsErrMsg.replace(/(&nbsp;)*$/, '')
          mainProductsErrMsg = mainProductsErrMsg.replace(/(<br\/>)$/, '')
          mainProductsErrMsg = mainProductsErrMsg.replace(/，$/, '')
        }
        return mainProductsErrMsg
      },
      findKey(obj, value, compare = (a, b) => a === b) {
        return Object.keys(obj).find(k => compare(obj[k], value))
      },
      initForm() {
        if (this.collection.length) {
          this.collection.forEach((item, index) => {
            const document = _.cloneDeep(item)
            const sign = this.findKey(signEnum, document.name)
            if (sign) {
              this.id[sign] = document.id
              const initForm = _.cloneDeep(document.content)
              this.fileList[sign] = [{name: initForm.bannerPath, url: initForm.bannerPath}]
              const signMainProductsArr = initForm.mainProducts
              let signMainProductsFormat = ''
              if (signMainProductsArr.length) {
                signMainProductsArr.forEach((item, index) => {
                  signMainProductsFormat += item + ','
                  if (index % 4 == 3) {
                    signMainProductsFormat += "\n"
                  }
                })
                signMainProductsFormat = signMainProductsFormat.replace(/[\n]$/, '')
              }
              initForm.mainProducts = signMainProductsFormat
              delete initForm.title
              delete initForm.cateId
              this.form[sign] = initForm
            }
          })
        }
      },
      customErrorClean(sign) {
        const signCustomErrorKey = sign + 'MainProducts'
        this.customError[signCustomErrorKey] = ''
      },
      customMarginBottom(errMsg) {
        const lineCount = errMsg ? (errMsg.match(/(<br\/>)/) ? errMsg.match(/(<br\/>)/).length + 1 : 1) : 0
        return lineCount ? 'custom-error-mb-cus' : 'custom-err-mb-def'
      }
    },
    async mounted() {
      const { activityId = 0 } = this.$route.query
      try {
        const { document } = await this.$store.dispatch('activities/document', activityId)
        this.activity = document
      } catch (err) {
        this.$message.error('活动不存在')
        this.$router.push({ name: 'activity-activity' })
      }
      this.init()
    }
  }
</script>
